import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { createContext, useContext, useState, useEffect, useRef, Fragment } from 'react';
import { getUrlParams, createFireboltForm, getFormattedPropsPresets, getFieldProps } from '@iq-firebolt/client-core';
export { clearAllFormSessions as clearFormSession } from '@iq-firebolt/client-core';
import { validateFBTStep, validateFBTField } from '@iq-firebolt/validators';
import evaluate from 'simple-evaluate';
import classNames from 'classnames';
import { createTextMaskInputElement } from 'text-mask-core';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import regexParser from 'regex-parser';
var FireboltContext = createContext({});
function useFirebolt() {
  var contextData = useContext(FireboltContext);
  return contextData;
}
function getDebugStepName() {
  var params = new URLSearchParams(window.location.search);
  var stepToDebug = params.get("debug-step") || "";
  return stepToDebug;
}
function useStates() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    formFlowHasBeenFinished = _useState4[0],
    setFormFlowHasBeenFinished = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    beforeProceedPayload = _useState6[0],
    setBeforeProceedPayload = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    lastSentPayload = _useState8[0],
    setLastSentPayload = _useState8[1];
  return {
    isFormLoading: isFormLoading,
    setIsFormLoading: setIsFormLoading,
    formFlowHasBeenFinished: formFlowHasBeenFinished,
    setFormFlowHasBeenFinished: setFormFlowHasBeenFinished,
    beforeProceedPayload: beforeProceedPayload,
    setBeforeProceedPayload: setBeforeProceedPayload,
    lastSentPayload: lastSentPayload,
    setLastSentPayload: setLastSentPayload
  };
}
var defaultStep = {
  data: {
    slug: "",
    type: "",
    friendlyName: "",
    fields: []
  },
  position: 0,
  webhookResult: {}
};
function useData() {
  var _useState9 = useState(defaultStep),
    _useState0 = _slicedToArray(_useState9, 2),
    currentStep = _useState0[0],
    setCurrentStep = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    stagedStep = _useState10[0],
    setStagedStep = _useState10[1];
  var _useState11 = useState({
      steps: [],
      lastStep: null
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    formflowMetadata = _useState12[0],
    setFormFlowMetadata = _useState12[1];
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    capturedData = _useState14[0],
    setCapturedData = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    remoteErrors = _useState16[0],
    setRemoteErrors = _useState16[1];
  var _useState17 = useState({}),
    _useState18 = _slicedToArray(_useState17, 2),
    lastVisitedStep = _useState18[0],
    setLastVisitedStep = _useState18[1];
  var _useState19 = useState({}),
    _useState20 = _slicedToArray(_useState19, 2),
    formEndPayload = _useState20[0],
    setFormEndPayload = _useState20[1];
  function clearRemoteFieldError(fieldSlug) {
    var safeRemote = remoteErrors || [];
    var filtered = safeRemote.filter(function (error) {
      return error.slug !== fieldSlug;
    });
    setRemoteErrors(filtered);
  }
  return {
    capturedData: capturedData,
    setCapturedData: setCapturedData,
    remoteErrors: remoteErrors,
    setRemoteErrors: setRemoteErrors,
    formflowMetadata: formflowMetadata,
    setFormFlowMetadata: setFormFlowMetadata,
    formEndPayload: formEndPayload,
    setFormEndPayload: setFormEndPayload,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    stagedStep: stagedStep,
    setStagedStep: setStagedStep,
    lastVisitedStep: lastVisitedStep,
    setLastVisitedStep: setLastVisitedStep,
    clearRemoteFieldError: clearRemoteFieldError
  };
}
function useBrowserNavigation(_ref) {
  var withHistory = _ref.withHistory,
    currentStep = _ref.currentStep,
    formflowMetadata = _ref.formflowMetadata,
    goPreviousStep = _ref.goPreviousStep,
    goNextStep = _ref.goNextStep,
    debug = _ref.debug,
    stepQueryParam = _ref.stepQueryParam;
  useEffect(function () {
    if (withHistory && !!currentStep.data.slug) {
      setPopStateEvent();
      updateBrowserHistory();
    }
  }, [currentStep]);
  function setPopStateEvent() {
    window.onpopstate = _onPopStateEventHandler;
  }
  function _onPopStateEventHandler() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _a;
    var previousStep = (_a = e == null ? void 0 : e.state) == null ? void 0 : _a.position;
    var totalSteps = Number(formflowMetadata == null ? void 0 : formflowMetadata.lastStep);
    var currentStepPosition = currentStep == null ? void 0 : currentStep.position;
    var isGoingToPreviousStep = !!previousStep && previousStep === currentStepPosition - 1;
    var isGoingToNextStep = !!previousStep && previousStep === currentStepPosition + 1 && currentStepPosition + 1 < totalSteps;
    if (isGoingToPreviousStep) {
      goPreviousStep();
    } else if (isGoingToNextStep) {
      goNextStep();
    }
  }
  function updateBrowserHistory() {
    var currentParams = getUrlParams();
    var isDebugging = !!debug && !!getDebugStepName();
    var queryParam = isDebugging ? "debug-step" : stepQueryParam;
    var filteredParamsKeys = Object.keys(currentParams).filter(function (key) {
      return key !== "debug-step" && key !== stepQueryParam;
    });
    var newQuery = filteredParamsKeys.reduce(function (acc, key) {
      return "".concat(acc, "&").concat(key, "=").concat(currentParams[key]);
    }, "");
    if (history) {
      history.pushState({
        slug: currentStep.data.slug,
        position: currentStep.position
      }, currentStep.data.friendlyName, "?".concat(queryParam, "=").concat(currentStep.data.slug).concat(newQuery));
    }
  }
}
var __defProp$a = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp$a(obj, key, value) {
  return key in obj ? __defProp$a(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues$a(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$a(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum$a.call(b, prop)) __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps$4(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
function useFireboltProvider(_ref2) {
  var formAccess = _ref2.formAccess,
    debug = _ref2.debug,
    _ref2$requestsMetadat = _ref2.requestsMetadata,
    requestsMetadata = _ref2$requestsMetadat === void 0 ? {} : _ref2$requestsMetadat,
    theme = _ref2.theme,
    withHistory = _ref2.withHistory,
    _ref2$stepQueryParam = _ref2.stepQueryParam,
    stepQueryParam = _ref2$stepQueryParam === void 0 ? "step" : _ref2$stepQueryParam,
    _ref2$addons = _ref2.addons,
    addons = _ref2$addons === void 0 ? {} : _ref2$addons,
    mockStep = _ref2.mockStep,
    _ref2$enforceNewSessi = _ref2.enforceNewSession,
    enforceNewSession = _ref2$enforceNewSessi === void 0 ? false : _ref2$enforceNewSessi;
  var formEngine = useRef(createFireboltForm(formAccess, {
    requestsMetadata: requestsMetadata,
    debug: debug,
    addons: addons,
    mockStep: mockStep,
    enforceNewSession: enforceNewSession
  }));
  var _useStates = useStates(),
    isFormLoading = _useStates.isFormLoading,
    setIsFormLoading = _useStates.setIsFormLoading,
    formFlowHasBeenFinished = _useStates.formFlowHasBeenFinished,
    setFormFlowHasBeenFinished = _useStates.setFormFlowHasBeenFinished,
    beforeProceedPayload = _useStates.beforeProceedPayload,
    setBeforeProceedPayload = _useStates.setBeforeProceedPayload,
    lastSentPayload = _useStates.lastSentPayload,
    setLastSentPayload = _useStates.setLastSentPayload;
  var _useData = useData(),
    capturedData = _useData.capturedData,
    setCapturedData = _useData.setCapturedData,
    remoteErrors = _useData.remoteErrors,
    setRemoteErrors = _useData.setRemoteErrors,
    formflowMetadata = _useData.formflowMetadata,
    setFormFlowMetadata = _useData.setFormFlowMetadata,
    formEndPayload = _useData.formEndPayload,
    setFormEndPayload = _useData.setFormEndPayload,
    currentStep = _useData.currentStep,
    setCurrentStep = _useData.setCurrentStep,
    stagedStep = _useData.stagedStep,
    setStagedStep = _useData.setStagedStep,
    lastVisitedStep = _useData.lastVisitedStep,
    setLastVisitedStep = _useData.setLastVisitedStep,
    clearRemoteFieldError = _useData.clearRemoteFieldError;
  useBrowserNavigation({
    withHistory: withHistory,
    currentStep: currentStep,
    formflowMetadata: formflowMetadata,
    goPreviousStep: goPreviousStep,
    goNextStep: goNextStep,
    stepQueryParam: stepQueryParam,
    debug: debug
  });
  useEffect(function () {
    var debugStep = getDebugStepName();
    if (!!debugStep) {
      if (!debug) throw new Error("Debug step is only allowed on debug mode: debug ".concat(debugStep));
      _startDebugStep(debugStep);
    } else {
      _startForm();
    }
  }, []);
  function _startForm() {
    setIsFormLoading(true);
    formEngine.current.start().then(function (data) {
      setIsFormLoading(false);
      setCurrentStep(data.step);
      setCapturedData(data.capturedData);
      setFormFlowMetadata(data.meta);
    }).catch(_handleTransitionError);
  }
  function _startDebugStep(stepSlug) {
    setIsFormLoading(true);
    return formEngine.current.debugStep(stepSlug).then(function (data) {
      setIsFormLoading(false);
      setCurrentStep(data.step);
      setCapturedData(data.capturedData);
      setFormFlowMetadata(data.meta);
    });
  }
  function goNextStep(stepFieldsPayload) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$extraRequestsMe = _ref3.extraRequestsMetaData,
      extraRequestsMetaData = _ref3$extraRequestsMe === void 0 ? {} : _ref3$extraRequestsMe;
    var _a;
    setIsFormLoading(true);
    setBeforeProceedPayload(stepFieldsPayload);
    setLastSentPayload(stepFieldsPayload);
    var isLastStep = ((_a = currentStep == null ? void 0 : currentStep.data) == null ? void 0 : _a.slug) === (formflowMetadata == null ? void 0 : formflowMetadata.lastStep);
    return formEngine.current.nextStep(currentStep.data.slug, stepFieldsPayload, {
      extraRequestsMetaData: extraRequestsMetaData
    }).then(function (data) {
      var _a2, _b, _c;
      var changedTrack = (_b = (_a2 = data == null ? void 0 : data.step) == null ? void 0 : _a2.webhookResult) == null ? void 0 : _b["newTrackSlug"];
      if (isLastStep && !changedTrack) {
        setFormEndPayload({
          webhookResult: (_c = data == null ? void 0 : data.step) == null ? void 0 : _c.webhookResult,
          capturedData: data == null ? void 0 : data.capturedData
        });
        setFormFlowHasBeenFinished(true);
        clearSession();
      } else {
        setCapturedData(data.capturedData);
        setStagedStep(data == null ? void 0 : data.step);
        setFormFlowMetadata(data.meta);
      }
    }).catch(function (err) {
      return _handleTransitionError(err, stepFieldsPayload);
    });
  }
  function goPreviousStep() {
    setIsFormLoading(true);
    return formEngine.current.previousStep(currentStep.data.slug).then(function (data) {
      setCapturedData(data.capturedData);
      setStagedStep(data.step);
      setFormFlowMetadata(data.meta);
    }).catch(_handleTransitionError);
  }
  function commitStepChange() {
    setLastVisitedStep(currentStep);
    setCurrentStep(stagedStep);
    setStagedStep(null);
    setIsFormLoading(false);
    setRemoteErrors([]);
  }
  function addRequestsMetadata(key) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    formEngine.current.addRequestMetadataItem(key, data);
  }
  function removeRequestsMetadata(key) {
    formEngine.current.removeRequestMetadataItem(key);
  }
  function getRequestsMetadata() {
    return formEngine.current.requestsMetadata;
  }
  function clearSession() {
    formEngine.current.clearSession();
  }
  function _handleTransitionError(err, fillData) {
    var _a, _b, _c, _d, _e;
    var invalidFields = ((_c = (_b = (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.errorData) == null ? void 0 : _c.invalidFields) || [];
    var isValidationError = ((_d = err == null ? void 0 : err.response) == null ? void 0 : _d.status) === 400 && !!invalidFields.length;
    if (isValidationError) {
      setRemoteErrors(invalidFields);
      if (fillData) {
        var safeFields = ((_e = currentStep == null ? void 0 : currentStep.data) == null ? void 0 : _e.fields) || [];
        var newFilledStepFields = safeFields.map(function (field) {
          return __spreadProps$4(__spreadValues$a({}, field), {
            value: fillData[field == null ? void 0 : field.slug]
          });
        });
        var newCurrentStep = __spreadProps$4(__spreadValues$a({}, currentStep), {
          data: __spreadProps$4(__spreadValues$a({}, currentStep == null ? void 0 : currentStep.data), {
            fields: newFilledStepFields
          })
        });
        setCurrentStep(newCurrentStep);
      }
      setIsFormLoading(false);
      return {
        errors: invalidFields
      };
    } else {
      var unexpectedError = [{
        "slug": "unexpected_error",
        "validationResults": [{
          "isValid": false,
          "message": "Erro inesperado, por favor tente novamente"
        }]
      }];
      setRemoteErrors(unexpectedError);
      setIsFormLoading(false);
      return {
        errors: unexpectedError
      };
    }
  }
  function addFieldRemoteError(fieldSlug, errorMessage) {
    var newRemoteError = {
      "slug": fieldSlug,
      "validationResults": [{
        "isValid": false,
        "message": errorMessage
      }]
    };
    setRemoteErrors([].concat(_toConsumableArray(remoteErrors), [newRemoteError]));
  }
  function uploadFile(file, fileName) {
    return formEngine.current.uploadFile(file, fileName);
  }
  return {
    isFormLoading: isFormLoading,
    formFlowHasBeenFinished: formFlowHasBeenFinished,
    currentStep: currentStep,
    stagedStep: stagedStep,
    formflowMetadata: formflowMetadata,
    capturedData: capturedData,
    formEndPayload: formEndPayload,
    lastVisitedStep: lastVisitedStep,
    remoteErrors: remoteErrors,
    theme: theme,
    goNextStep: goNextStep,
    goPreviousStep: goPreviousStep,
    commitStepChange: commitStepChange,
    addRequestsMetadata: addRequestsMetadata,
    removeRequestsMetadata: removeRequestsMetadata,
    getRequestsMetadata: getRequestsMetadata,
    uploadFile: uploadFile,
    clearSession: clearSession,
    clearRemoteFieldError: clearRemoteFieldError,
    beforeProceedPayload: beforeProceedPayload,
    setBeforeProceedPayload: setBeforeProceedPayload,
    addFieldRemoteError: addFieldRemoteError,
    lastSentPayload: lastSentPayload,
    setLastSentPayload: setLastSentPayload
  };
}
var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp$9(obj, key, value) {
  return key in obj ? __defProp$9(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues$9(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$9(b)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (__propIsEnum$9.call(b, prop)) __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return a;
};
var FireboltProvider = function FireboltProvider(props) {
  var values = useFireboltProvider(props);
  return /* @__PURE__ */React.createElement(FireboltContext.Provider, __spreadValues$9({
    value: values
  }, props));
};
var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp$8(obj, key, value) {
  return key in obj ? __defProp$8(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues$8(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$8(b)),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$8.call(b, prop)) __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return a;
};
var createFireboltProvider = function createFireboltProvider(_ref4) {
  var formAccess = _ref4.formAccess,
    debug = _ref4.debug,
    stepQueryParam = _ref4.stepQueryParam,
    requestsMetadata = _ref4.requestsMetadata,
    withHistory = _ref4.withHistory,
    addons = _ref4.addons,
    mockStep = _ref4.mockStep,
    enforceNewSession = _ref4.enforceNewSession;
  return function (Component) {
    return function (props) {
      return /* @__PURE__ */React.createElement(FireboltProvider, {
        formAccess: formAccess,
        debug: debug,
        stepQueryParam: stepQueryParam,
        requestsMetadata: requestsMetadata,
        withHistory: withHistory,
        addons: addons,
        mockStep: mockStep,
        enforceNewSession: enforceNewSession
      }, /* @__PURE__ */React.createElement(Component, __spreadValues$8({}, props)));
    };
  };
};
function useWizard(_ref5) {
  var onChangeStep = _ref5.onChangeStep,
    onConnectionError = _ref5.onConnectionError,
    onFinishForm = _ref5.onFinishForm,
    onBeforeChangeStep = _ref5.onBeforeChangeStep,
    onBeforeProceed = _ref5.onBeforeProceed;
  var _a;
  var _useFirebolt = useFirebolt(),
    isFormLoading = _useFirebolt.isFormLoading,
    currentStep = _useFirebolt.currentStep,
    lastVisitedStep = _useFirebolt.lastVisitedStep,
    formFlowHasBeenFinished = _useFirebolt.formFlowHasBeenFinished,
    formEndPayload = _useFirebolt.formEndPayload,
    stagedStep = _useFirebolt.stagedStep,
    commitStepChange = _useFirebolt.commitStepChange,
    connectionError = _useFirebolt.connectionError,
    setBeforeProceedPayload = _useFirebolt.setBeforeProceedPayload,
    beforeProceedPayload = _useFirebolt.beforeProceedPayload;
  useEffect(onStepChangeHandler, [currentStep]);
  useEffect(function () {
    if (!!stagedStep) onBeforeStepChangeHandler();
  }, [stagedStep]);
  useEffect(onConnectionErrorHandler, [connectionError]);
  useEffect(onFormFinishedCallback, [formFlowHasBeenFinished]);
  useEffect(onBeforeProceedHandler, [beforeProceedPayload]);
  function onConnectionErrorHandler() {
    if (connectionError && !!onConnectionError) {
      onConnectionError();
    }
  }
  function onBeforeProceedHandler() {
    if (!!beforeProceedPayload) {
      if (!!onBeforeProceed) {
        onBeforeProceed(currentStep, beforeProceedPayload);
      }
      setBeforeProceedPayload(null);
    }
  }
  function onBeforeStepChangeHandler() {
    var proceedCallback = function proceedCallback() {
      return commitStepChange();
    };
    if (!!onBeforeChangeStep) {
      onBeforeChangeStep(proceedCallback, {
        leavingStep: currentStep,
        enteringStep: stagedStep
      });
    } else {
      proceedCallback();
    }
  }
  function onStepChangeHandler() {
    var notIsFirstStepRendered = !!(lastVisitedStep == null ? void 0 : lastVisitedStep.position);
    if (notIsFirstStepRendered && !!onChangeStep) {
      onChangeStep({
        sentStep: lastVisitedStep,
        currentStep: currentStep
      });
    }
  }
  function onFormFinishedCallback() {
    if (!!formFlowHasBeenFinished && !!onFinishForm) {
      var payload = formEndPayload || {};
      onFinishForm(payload);
    }
  }
  return {
    isFormLoading: isFormLoading,
    currentStepSlug: (_a = currentStep == null ? void 0 : currentStep.data) == null ? void 0 : _a.slug
  };
}
function filterChildren(children, currentStepSlug) {
  if (!children) return null;
  var childrenArray = React.Children.toArray(children);
  var exactMatch = childrenArray.find(function (child) {
    var _a, _b;
    return ((_b = (_a = child == null ? void 0 : child.props) == null ? void 0 : _a.match) == null ? void 0 : _b.slug) === currentStepSlug;
  });
  var getFirstGeneralCaseItem = function getFirstGeneralCaseItem() {
    return childrenArray.find(function (child) {
      var _a;
      var childMatch = (_a = child == null ? void 0 : child.props) == null ? void 0 : _a.match;
      return !childMatch || childMatch === "*";
    });
  };
  return exactMatch ? exactMatch : getFirstGeneralCaseItem();
}
var __defProp$7 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp$7(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues$7(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7) {
    var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$7(b)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var prop = _step4.value;
        if (__propIsEnum$7.call(b, prop)) __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps$3(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
var __objRest$1 = function __objRest$1(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$7(source)),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var prop = _step5.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  return target;
};
function useStep() {
  var _useFirebolt2 = useFirebolt(),
    goNextStep = _useFirebolt2.goNextStep,
    goPreviousStep = _useFirebolt2.goPreviousStep,
    currentStep = _useFirebolt2.currentStep,
    formflowMetadata = _useFirebolt2.formflowMetadata,
    capturedData = _useFirebolt2.capturedData,
    remoteErrors = _useFirebolt2.remoteErrors,
    clearSession = _useFirebolt2.clearSession,
    clearRemoteFieldError = _useFirebolt2.clearRemoteFieldError;
  var _a = currentStep,
    _a$data = _a.data,
    stepData = _a$data === void 0 ? {} : _a$data,
    rest = __objRest$1(_a, ["data"]);
  var fireboltStep = __spreadProps$3(__spreadValues$7(__spreadValues$7({}, rest), stepData), {
    goNextStep: goNextStep,
    goPreviousStep: goPreviousStep,
    formflowMetadata: formflowMetadata,
    capturedData: capturedData,
    remoteErrors: remoteErrors,
    clearSession: clearSession,
    clearRemoteFieldError: clearRemoteFieldError
  });
  return {
    fireboltStep: fireboltStep
  };
}
var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6) {
    var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var prop = _step6.value;
        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6) {
    var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols$6(source)),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var prop = _step7.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }
  return target;
};
var Step = function Step(_a) {
  var _b = _a,
    component = _b.component,
    props = __objRest(_b, ["component"]);
  var _useStep = useStep(),
    fireboltStep = _useStep.fireboltStep;
  var FormStepComponent = component;
  return /* @__PURE__ */React.createElement(FormStepComponent, __spreadValues$6({
    fireboltStep: fireboltStep
  }, props));
};
var Wizard = function Wizard(_ref6) {
  var children = _ref6.children,
    fallback = _ref6.fallback,
    onChangeStep = _ref6.onChangeStep,
    onConnectionError = _ref6.onConnectionError,
    onFinishForm = _ref6.onFinishForm,
    onBeforeChangeStep = _ref6.onBeforeChangeStep,
    onBeforeProceed = _ref6.onBeforeProceed;
  var _useWizard = useWizard({
      onChangeStep: onChangeStep,
      onConnectionError: onConnectionError,
      onFinishForm: onFinishForm,
      onBeforeChangeStep: onBeforeChangeStep,
      onBeforeProceed: onBeforeProceed
    }),
    isFormLoading = _useWizard.isFormLoading,
    currentStepSlug = _useWizard.currentStepSlug;
  return /* @__PURE__ */React.createElement(Fragment, null, isFormLoading ? !!fallback ? fallback : null : filterChildren(children, currentStepSlug));
};
Wizard.Step = Step;
var classes = {
  "firebolt-input": "style-module_firebolt-input__b7RQR",
  "insert-wrapper": "style-module_insert-wrapper__6JIOB",
  "firebolt-form-wrapper": "style-module_firebolt-form-wrapper__rosjT",
  "firebolt-input--half": "style-module_firebolt-input--half__ibbGQ"
};
var Insert = function Insert(_ref7) {
  var before = _ref7.before,
    after = _ref7.after,
    render = _ref7.render;
  return /* @__PURE__ */React.createElement("div", {
    className: classes["insert-wrapper"]
  }, render);
};
var __defProp$5 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp$5(obj, key, value) {
  return key in obj ? __defProp$5(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5) {
    var _iterator8 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var prop = _step8.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps$2(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
function useFormState(_ref8) {
  var schema = _ref8.schema,
    autoFill = _ref8.autoFill,
    remoteErrors = _ref8.remoteErrors,
    addons = _ref8.addons;
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isFormValid = _useState22[0],
    setIsFormValid = _useState22[1];
  var _useState23 = useState({}),
    _useState24 = _slicedToArray(_useState23, 2),
    formPayload = _useState24[0],
    setFormPayload = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    hasFormChanged = _useState26[0],
    setHasFormChanged = _useState26[1];
  var _useState27 = useState(),
    _useState28 = _slicedToArray(_useState27, 2),
    standalonePropsPresets = _useState28[0],
    setStandalonePropsPresets = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isHavingInternaLoading = _useState30[0],
    setIsHavingInternalLoading = _useState30[1];
  var _useState31 = useState({}),
    _useState32 = _slicedToArray(_useState31, 2),
    fieldValidationErrors = _useState32[0],
    setFieldValidationErrors = _useState32[1];
  var _useState33 = useState({}),
    _useState34 = _slicedToArray(_useState33, 2),
    fieldManuallySetErrors = _useState34[0],
    setFieldManuallySetErrors = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    requiredFieldsSlugs = _useState36[0],
    setRequiredFieldsSlugs = _useState36[1];
  useEffect(validateForm, [formPayload, fieldManuallySetErrors]);
  useEffect(autoFillFromProp, [autoFill]);
  useEffect(autoFillFromAPI, [schema]);
  useEffect(setRemoteErrors, [remoteErrors]);
  useEffect(setupStandalonePropsPresets, [addons]);
  useEffect(function () {
    var requiredFields = schema.filter(function (field) {
      var _a;
      return (_a = field == null ? void 0 : field.validators) == null ? void 0 : _a.find(function (validator) {
        return validator.type === "required";
      });
    });
    var slugs = requiredFields.map(function (field) {
      return field.slug;
    });
    setRequiredFieldsSlugs(slugs);
  }, [schema]);
  function setupStandalonePropsPresets() {
    if (addons == null ? void 0 : addons.uiPropsPresets) {
      var formattedPropsPresets = getFormattedPropsPresets(addons.uiPropsPresets);
      setStandalonePropsPresets(formattedPropsPresets);
    } else {
      setStandalonePropsPresets(void 0);
    }
  }
  function autoFillFromProp() {
    var newPayload = __spreadValues$5(__spreadValues$5({}, formPayload), autoFill);
    if (!!autoFill) {
      setFormPayload(newPayload);
    }
  }
  function getNewRemoteErrors() {
    var safeRemoteErrors = remoteErrors || [];
    return safeRemoteErrors.reduce(function (acc, nxtItem) {
      var _a;
      var safeNextObj = nxtItem || {};
      var validatorResult = safeNextObj["validationResults"] || [];
      return __spreadProps$2(__spreadValues$5({}, acc), _defineProperty({}, nxtItem == null ? void 0 : nxtItem.slug, (_a = validatorResult[0]) == null ? void 0 : _a.message));
    }, {});
  }
  function setRemoteErrors() {
    if (remoteErrors == null ? void 0 : remoteErrors.length) {
      var newErrorModel = getNewRemoteErrors();
      setFieldValidationErrors(__spreadValues$5(__spreadValues$5({}, fieldValidationErrors), newErrorModel));
    }
  }
  function autoFillFromAPI() {
    var autoFilledPayload = schema.reduce(function (acc, field) {
      var slug = field.slug,
        value = field.value;
      var autoFillObj = value ? _defineProperty({}, slug, value) : {};
      return __spreadValues$5(__spreadValues$5({}, acc), autoFillObj);
    }, {});
    setFormPayload(autoFilledPayload);
  }
  function setFieldWarning(fieldSlug, message) {
    var manualSetError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var usedState = manualSetError ? fieldManuallySetErrors : fieldValidationErrors;
    var usedSetter = manualSetError ? setFieldManuallySetErrors : setFieldValidationErrors;
    usedSetter(__spreadProps$2(__spreadValues$5({}, usedState), _defineProperty({}, fieldSlug, message)));
  }
  function clearFieldWarning(fieldSlug) {
    var manualSetError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var usedState = manualSetError ? fieldManuallySetErrors : fieldValidationErrors;
    var usedSetter = manualSetError ? setFieldManuallySetErrors : setFieldValidationErrors;
    var erroredFieldsSlugs = Object.keys(usedState);
    var filteredSlugs = erroredFieldsSlugs.filter(function (slug) {
      return slug !== fieldSlug;
    });
    var newErroredFields = filteredSlugs.reduce(function (acc, slug) {
      return __spreadProps$2(__spreadValues$5({}, acc), _defineProperty({}, slug, usedState[slug]));
    }, {});
    usedSetter(newErroredFields);
  }
  function getFormValidation() {
    return validateFBTStep({
      stepFields: schema,
      formPayload: formPayload,
      context: "client"
    });
  }
  function validateForm() {
    var stepValidation = getFormValidation();
    var isFormValidCheck = stepValidation.isValid;
    var hasFieldsError = !!Object.keys(fieldValidationErrors).length;
    var hasManualSetErrors = !!Object.keys(fieldManuallySetErrors).length;
    if (isFormValidCheck && !hasFieldsError && !hasManualSetErrors) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }
  function markAllInvalidFields() {
    var formValidation = getFormValidation();
    var invalidFields = (formValidation == null ? void 0 : formValidation.invalidFields) || [];
    var errorsObject = invalidFields.reduce(function (acc, field) {
      var _a, _b;
      var fieldSlug = field == null ? void 0 : field.slug;
      var errorMessage = (_b = (_a = field == null ? void 0 : field.validationResults) == null ? void 0 : _a[0]) == null ? void 0 : _b.message;
      return __spreadProps$2(__spreadValues$5({}, acc), _defineProperty({}, fieldSlug, errorMessage));
    }, {});
    var remoteErrorsObject = getNewRemoteErrors();
    setFieldValidationErrors(__spreadValues$5(__spreadValues$5({}, errorsObject), remoteErrorsObject));
  }
  function modifyPayloadKeys() {
    var newData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var newPayload = __spreadValues$5(__spreadValues$5({}, formPayload), newData);
    setFormPayload(newPayload);
    return newPayload;
  }
  return {
    isFormValid: isFormValid,
    formPayload: formPayload,
    fieldValidationErrors: fieldValidationErrors,
    fieldManuallySetErrors: fieldManuallySetErrors,
    modifyPayloadKeys: modifyPayloadKeys,
    hasFormChanged: hasFormChanged,
    setHasFormChanged: setHasFormChanged,
    isHavingInternaLoading: isHavingInternaLoading,
    setIsHavingInternalLoading: setIsHavingInternalLoading,
    setFieldWarning: setFieldWarning,
    clearFieldWarning: clearFieldWarning,
    markAllInvalidFields: markAllInvalidFields,
    standalonePropsPresets: standalonePropsPresets,
    requiredFieldsSlugs: requiredFieldsSlugs,
    setRemoteErrors: setRemoteErrors
  };
}
function useFieldsEvents(_ref0) {
  var formPayload = _ref0.formPayload,
    onChange = _ref0.onChange,
    onSubmit = _ref0.onSubmit,
    isFormValid = _ref0.isFormValid,
    hasFormChanged = _ref0.hasFormChanged,
    markAllInvalidFields = _ref0.markAllInvalidFields,
    onGoBack = _ref0.onGoBack,
    requiredFieldsSlugs = _ref0.requiredFieldsSlugs,
    remoteErrors = _ref0.remoteErrors,
    setRemoteErrors = _ref0.setRemoteErrors;
  useEffect(function () {
    if (!!onChange && hasFormChanged) {
      onChange(formPayload);
    }
  }, [formPayload, onChange]);
  useEffect(function () {
    var isAllRequiredFieldsFilled = requiredFieldsSlugs.every(function (item) {
      return !!formPayload[item];
    });
    if (isAllRequiredFieldsFilled && requiredFieldsSlugs.length) markAllInvalidFields();
    if (remoteErrors == null ? void 0 : remoteErrors.length) setRemoteErrors();
  }, [formPayload]);
  function handleSubmit(e) {
    if (e && (e == null ? void 0 : e.preventDefault)) e == null ? void 0 : e.preventDefault();
    if (!!onSubmit && isFormValid) {
      onSubmit(formPayload);
    }
    if (!isFormValid) {
      markAllInvalidFields();
    }
  }
  function handleGoBack(e) {
    e == null ? void 0 : e.preventDefault();
    if (!!onGoBack) {
      onGoBack(formPayload);
    }
  }
  return {
    handleSubmit: handleSubmit,
    handleGoBack: handleGoBack
  };
}
var RequestThemePlaceholder = function RequestThemePlaceholder(_ref1) {
  var fieldName = _ref1.fieldName;
  return /* @__PURE__ */React.createElement("div", {
    style: {
      "backgroundColor": "gray",
      padding: "20px"
    }
  }, /* @__PURE__ */React.createElement("p", {
    style: {
      color: "white",
      fontSize: "20px"
    }
  }, "Please, add a firebolt theme with ", /* @__PURE__ */React.createElement("strong", null, fieldName), " widget support"));
};
function getFieldComponent(_ref10) {
  var _ref10$customTheme = _ref10.customTheme,
    customTheme = _ref10$customTheme === void 0 ? {} : _ref10$customTheme,
    widgetName = _ref10.widgetName;
  var customComponent = customTheme[widgetName];
  if (!!customComponent) return customComponent;else return function () {
    return /* @__PURE__ */React.createElement(RequestThemePlaceholder, {
      fieldName: widgetName
    });
  };
}
var __defProp$4 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp$4(obj, key, value) {
  return key in obj ? __defProp$4(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4) {
    var _iterator9 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var prop = _step9.value;
        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
function remapFormChildren(_ref11) {
  var _ref11$fieldsChildren = _ref11.fieldsChildren,
    fieldsChildren = _ref11$fieldsChildren === void 0 ? [] : _ref11$fieldsChildren,
    _ref11$insertsChildre = _ref11.insertsChildren,
    insertsChildren = _ref11$insertsChildre === void 0 ? [] : _ref11$insertsChildre;
  var insertsChildrenArray = React.Children.toArray(insertsChildren);
  var slugInsertsMap = insertsChildrenArray.reduce(function (acc, insertComponent) {
    var _a, _b, _c, _d;
    var componentProps = insertComponent == null ? void 0 : insertComponent.props;
    var insertBefore = componentProps == null ? void 0 : componentProps.before;
    var insertAfter = componentProps == null ? void 0 : componentProps.after;
    var usedInsert = insertBefore || insertAfter;
    var insertRelativeToFirstField = usedInsert === "first";
    var insertRelativeToLastField = usedInsert === "last";
    var getUsedInsertReference = function getUsedInsertReference() {
      if (insertRelativeToFirstField || insertRelativeToLastField) {
        return usedInsert;
      } else return usedInsert == null ? void 0 : usedInsert.fieldSlug;
    };
    var usedInsertReference = getUsedInsertReference();
    var componentRefs = {
      after: !!insertAfter ? [insertComponent] : [],
      before: !!insertBefore ? [insertComponent] : []
    };
    return __spreadProps$1(__spreadValues$4({}, acc), _defineProperty({}, usedInsertReference, {
      before: ((_a = acc == null ? void 0 : acc[usedInsertReference]) == null ? void 0 : _a.before) ? [].concat(_toConsumableArray((_b = acc == null ? void 0 : acc[usedInsertReference]) == null ? void 0 : _b.before), _toConsumableArray(componentRefs == null ? void 0 : componentRefs.before)) : componentRefs == null ? void 0 : componentRefs.before,
      after: ((_c = acc == null ? void 0 : acc[usedInsertReference]) == null ? void 0 : _c.after) ? [].concat(_toConsumableArray((_d = acc == null ? void 0 : acc[usedInsertReference]) == null ? void 0 : _d.after), _toConsumableArray(componentRefs == null ? void 0 : componentRefs.after)) : componentRefs == null ? void 0 : componentRefs.after
    }));
  }, {});
  var remapedChildren = fieldsChildren.reduce(function (acc, field, index) {
    var _a, _b, _c;
    var isFirstItem = index === 0;
    var isLastItem = index === (fieldsChildren == null ? void 0 : fieldsChildren.length) - 1;
    var isDefinedSpot = isFirstItem || isLastItem;
    var fieldSlug = (_a = field == null ? void 0 : field.props) == null ? void 0 : _a.fieldSlug;
    var beforeInserts = ((_b = slugInsertsMap == null ? void 0 : slugInsertsMap[fieldSlug]) == null ? void 0 : _b.before) || [];
    var afterInserts = ((_c = slugInsertsMap == null ? void 0 : slugInsertsMap[fieldSlug]) == null ? void 0 : _c.after) || [];
    var withDefinedSpotInserts = function withDefinedSpotInserts() {
      if (isDefinedSpot) {
        var definedSpotLabel = isFirstItem ? "first" : isLastItem ? "last" : null;
        var spotedInsets = slugInsertsMap == null ? void 0 : slugInsertsMap[definedSpotLabel];
        var spotedAfterInserts = (spotedInsets == null ? void 0 : spotedInsets.after) || [];
        var spotedBeforeInserts = (spotedInsets == null ? void 0 : spotedInsets.before) || [];
        return {
          after: [].concat(_toConsumableArray(afterInserts), _toConsumableArray(spotedAfterInserts)),
          before: [].concat(_toConsumableArray(beforeInserts), _toConsumableArray(spotedBeforeInserts))
        };
      } else {
        return {
          after: _toConsumableArray(afterInserts),
          before: _toConsumableArray(beforeInserts)
        };
      }
    };
    var _withDefinedSpotInser = withDefinedSpotInserts(),
      beforeField = _withDefinedSpotInser.before,
      afterField = _withDefinedSpotInser.after;
    return [].concat(_toConsumableArray(acc), _toConsumableArray(beforeField), [field], _toConsumableArray(afterField));
  }, []);
  return remapedChildren;
}
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp$3(obj, key, value) {
  return key in obj ? __defProp$3(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3) {
    var _iterator0 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
      _step0;
    try {
      for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
        var prop = _step0.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator0.e(err);
    } finally {
      _iterator0.f();
    }
  }
  return a;
};
function getConditionalProps(_ref12) {
  var propsConditional = _ref12.propsConditional,
    formPayload = _ref12.formPayload;
  if (!propsConditional) return {};
  var safePropsConditional = propsConditional || [];
  return safePropsConditional.reduce(function (acc, _ref13) {
    var _ref13$conditional = _ref13.conditional,
      conditional = _ref13$conditional === void 0 ? "" : _ref13$conditional,
      _ref13$props = _ref13.props,
      props = _ref13$props === void 0 ? {} : _ref13$props;
    var isConditionValid = evaluate({
      step: formPayload
    }, conditional);
    return __spreadValues$3(__spreadValues$3({}, acc), isConditionValid ? __spreadValues$3({}, props) : {});
  }, {});
}
function validateField(_ref14) {
  var value = _ref14.value,
    field = _ref14.field,
    formPayload = _ref14.formPayload;
  return validateFBTField({
    value: value,
    field: field,
    formPayload: formPayload,
    context: "client"
  });
}
function parseMask(rawMask) {
  if (!rawMask) return;
  if (typeof rawMask === "function") {
    return function (value) {
      var resolvedMask = rawMask(value);
      var stringMask = parseMask(resolvedMask);
      return stringMask;
    };
  } else if (Array.isArray(rawMask)) {
    return rawMask.map(function (item) {
      var isEncodedRegex = typeof item === "string" && item.startsWith("/") && item.endsWith("/") && item !== "/";
      var isRegex = item instanceof RegExp;
      if (isRegex) {
        return item;
      } else if (isEncodedRegex) {
        return regexParser(item);
      }
      return item;
    });
  } else if (typeof rawMask === "object") {
    return createNumberMask(rawMask);
  }
}
function useMaskedInput(_ref15) {
  var input = _ref15.input,
    mask = _ref15.mask,
    onChange = _ref15.onChange,
    _ref15$value = _ref15.value,
    value = _ref15$value === void 0 ? "" : _ref15$value;
  var textMask = useRef();
  useEffect(init, [mask]);
  function init() {
    if (!input.current) return;
    textMask.current = createTextMaskInputElement({
      inputElement: input.current,
      mask: mask ? parseMask(mask) : mask
    });
    textMask.current.update(value);
  }
  return function () {
    var _a;
    if (textMask.current) {
      textMask.current.update();
    }
    if (typeof onChange === "function") {
      onChange((_a = input == null ? void 0 : input.current) == null ? void 0 : _a.value);
    }
  };
}
var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    var _iterator1 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
      _step1;
    try {
      for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
        var prop = _step1.value;
        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator1.e(err);
    } finally {
      _iterator1.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function useInputHolder(_ref16) {
  var fieldConfig = _ref16.fieldConfig,
    formPayload = _ref16.formPayload,
    hasFormChanged = _ref16.hasFormChanged,
    setHasFormChanged = _ref16.setHasFormChanged,
    modifyPayloadKeys = _ref16.modifyPayloadKeys,
    clearFieldWarning = _ref16.clearFieldWarning,
    setFieldWarning = _ref16.setFieldWarning,
    onFocusField = _ref16.onFocusField,
    onBlurField = _ref16.onBlurField,
    onChangeField = _ref16.onChangeField,
    classes = _ref16.classes,
    fieldManuallySetErrors = _ref16.fieldManuallySetErrors,
    fieldValidationErrors = _ref16.fieldValidationErrors,
    isRequiredField = _ref16.isRequiredField,
    standalonePropsPresets = _ref16.standalonePropsPresets,
    clearRemoteFieldError = _ref16.clearRemoteFieldError,
    remoteErrors = _ref16.remoteErrors;
  var slug = fieldConfig.slug,
    _fieldConfig$meta = fieldConfig.meta,
    meta = _fieldConfig$meta === void 0 ? {} : _fieldConfig$meta,
    _fieldConfig$uiProps = fieldConfig["ui:props"],
    propsFromSchema = _fieldConfig$uiProps === void 0 ? {} : _fieldConfig$uiProps,
    propsStyles = fieldConfig["ui:styles"],
    propsConditional = fieldConfig["ui:props-conditional"];
  var fieldId = "firebolt-form-field-".concat(slug);
  var value = formPayload[slug] || "";
  var hasError = Object.keys(fieldValidationErrors).includes(slug) || Object.keys(fieldManuallySetErrors).includes(slug);
  var errorMessage = (fieldValidationErrors == null ? void 0 : fieldValidationErrors[slug]) || (fieldManuallySetErrors == null ? void 0 : fieldManuallySetErrors[slug]) || "Campo inv\xE1lido";
  var computedClasses = classNames(classes["firebolt-input"], _defineProperty({}, classes["firebolt-input--half"], (propsStyles == null ? void 0 : propsStyles.size) === "half"));
  var fieldsPropsConditional = getConditionalProps({
    formPayload: formPayload,
    propsConditional: propsConditional
  });
  var standalonePropsPresetsMap = function () {
    if (!standalonePropsPresets) return {};
    return getFieldProps(fieldConfig, standalonePropsPresets.collectionsMap, standalonePropsPresets.allPresetsMap);
  }() || {};
  var inputRef = useRef();
  var mask = propsFromSchema.mask || fieldsPropsConditional.mask || standalonePropsPresetsMap.mask;
  var onChangeMask = useMaskedInput({
    input: inputRef,
    mask: mask ? mask : false,
    value: value,
    onChange: function onChange(value2) {
      return onChangeFieldHandler(value2);
    }
  });
  function onChangeFieldHandler(value2) {
    var fieldSlug = fieldConfig == null ? void 0 : fieldConfig.slug;
    var currentValue = formPayload[fieldSlug];
    var isValueValid = validateField({
      field: fieldConfig,
      value: value2,
      formPayload: formPayload
    }).isValid;
    var newFormPayload = modifyPayloadKeys(_defineProperty({}, fieldSlug, value2));
    if (isValueValid) {
      var safeRemoteErrors = remoteErrors || [];
      var hasRemoteError = safeRemoteErrors == null ? void 0 : safeRemoteErrors.find(function (item) {
        return item.slug === fieldConfig.slug;
      });
      clearFieldWarning(fieldSlug);
      if (hasRemoteError && clearRemoteFieldError) {
        clearRemoteFieldError(fieldConfig.slug);
      }
    }
    if (!hasFormChanged) setHasFormChanged(true);
    if (onChangeField) onChangeField(fieldConfig, {
      value: value2,
      previousValue: currentValue,
      isValid: isValueValid
    }, newFormPayload);
  }
  function onBlurFieldHandler(value2) {
    var _a, _b;
    var fieldSlug = fieldConfig == null ? void 0 : fieldConfig.slug;
    var fieldValidation = validateField({
      field: fieldConfig,
      value: value2,
      formPayload: formPayload
    });
    var isValueValid = fieldValidation.isValid;
    var checkSpaces = /( )+/g;
    if (isValueValid) {
      var safeRemoteErrors = remoteErrors || [];
      var hasRemoteError = safeRemoteErrors == null ? void 0 : safeRemoteErrors.find(function (item) {
        return item.slug === fieldConfig.slug;
      });
      if (!hasRemoteError) {
        clearFieldWarning(fieldSlug);
      }
    } else {
      var errorMessage2 = ((_b = (_a = fieldValidation == null ? void 0 : fieldValidation.invalidValidations) == null ? void 0 : _a[0]) == null ? void 0 : _b.message) || "";
      setFieldWarning(fieldSlug, errorMessage2);
    }
    if (checkSpaces.test(value2)) {
      modifyPayloadKeys(_defineProperty({}, fieldSlug, value2.replace(checkSpaces, " ").trim()));
    }
    if (onBlurField) onBlurField(fieldConfig, value2, formPayload, isValueValid);
  }
  function onFocusFieldHandler() {
    if (!!onFocusField) {
      onFocusField(fieldConfig, formPayload);
    }
  }
  function manuallySetFieldErrorHandler(message) {
    setFieldWarning(slug, message, true);
  }
  function clearManuallySetErrorHandler() {
    clearFieldWarning(slug, true);
  }
  var fieldProps = __spreadProps(__spreadValues$2(__spreadValues$2(__spreadValues$2({}, propsFromSchema), standalonePropsPresetsMap), fieldsPropsConditional), {
    fieldId: fieldId,
    inputRef: inputRef,
    slug: slug,
    value: value,
    hasError: hasError,
    meta: meta,
    payload: formPayload,
    isValid: !hasError,
    isRequired: isRequiredField,
    isOptional: !isRequiredField,
    errorMessage: errorMessage,
    modifyPayloadKeys: modifyPayloadKeys,
    fieldValidators: (fieldConfig == null ? void 0 : fieldConfig.validators) || [],
    onChange: mask ? onChangeMask : onChangeFieldHandler,
    onBlur: onBlurFieldHandler,
    onFocus: onFocusFieldHandler,
    manuallySetFieldError: manuallySetFieldErrorHandler,
    clearManuallySetError: clearManuallySetErrorHandler
  });
  return {
    computedClasses: computedClasses,
    slug: slug,
    fieldProps: fieldProps
  };
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    var _iterator10 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var prop = _step10.value;
        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
  }
  return a;
};
var InputHolder = function InputHolder(props) {
  var _useInputHolder = useInputHolder(props),
    computedClasses = _useInputHolder.computedClasses,
    slug = _useInputHolder.slug,
    fieldProps = _useInputHolder.fieldProps;
  var FieldComponent = props.FieldComponent;
  return /* @__PURE__ */React.createElement("div", {
    className: computedClasses,
    "data-fieldslug": slug
  }, /* @__PURE__ */React.createElement(FieldComponent, __spreadValues$1({}, fieldProps)));
};
function useFormRendering(_ref17) {
  var schema = _ref17.schema,
    theme = _ref17.theme,
    insertsChildren = _ref17.children,
    formPayload = _ref17.formPayload,
    modifyPayloadKeys = _ref17.modifyPayloadKeys,
    fieldValidationErrors = _ref17.fieldValidationErrors,
    fieldManuallySetErrors = _ref17.fieldManuallySetErrors,
    setFieldWarning = _ref17.setFieldWarning,
    clearFieldWarning = _ref17.clearFieldWarning,
    standalonePropsPresets = _ref17.standalonePropsPresets,
    hasFormChanged = _ref17.hasFormChanged,
    setHasFormChanged = _ref17.setHasFormChanged,
    onFocusField = _ref17.onFocusField,
    onChangeField = _ref17.onChangeField,
    onBlurField = _ref17.onBlurField,
    classes = _ref17.classes,
    clearRemoteFieldError = _ref17.clearRemoteFieldError,
    remoteErrors = _ref17.remoteErrors;
  var fieldsChildren = schema.map(function () {
    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var index = arguments.length > 1 ? arguments[1] : undefined;
    var conditional = field.conditional,
      widgetName = field["ui:widget"];
    var safeTheme = theme || {};
    var hasConditionalRender = !!conditional;
    var isConditionallyValid = hasConditionalRender ? evaluate({
      step: formPayload
    }, conditional) : true;
    var shouldHideField = widgetName === "hidden" || !isConditionallyValid;
    var fieldValidators = (field == null ? void 0 : field.validators) || [];
    var isRequiredField = !!fieldValidators.find(function (validator) {
      return (validator == null ? void 0 : validator.type) === "required";
    });
    var FieldComponent = getFieldComponent({
      widgetName: widgetName,
      customTheme: safeTheme
    });
    if (!shouldHideField) {
      return /* @__PURE__ */React.createElement(InputHolder, {
        fieldConfig: field,
        fieldSlug: field.slug,
        formPayload: formPayload,
        FieldComponent: FieldComponent,
        key: "form-item-".concat(index),
        hasFormChanged: hasFormChanged,
        setHasFormChanged: setHasFormChanged,
        modifyPayloadKeys: modifyPayloadKeys,
        clearFieldWarning: clearFieldWarning,
        setFieldWarning: setFieldWarning,
        onFocusField: onFocusField,
        onBlurField: onBlurField,
        onChangeField: onChangeField,
        classes: classes,
        fieldManuallySetErrors: fieldManuallySetErrors,
        fieldValidationErrors: fieldValidationErrors,
        isRequiredField: isRequiredField,
        standalonePropsPresets: standalonePropsPresets,
        clearRemoteFieldError: clearRemoteFieldError,
        remoteErrors: remoteErrors
      });
    }
  });
  var formChildren = remapFormChildren({
    fieldsChildren: fieldsChildren,
    insertsChildren: insertsChildren
  });
  return {
    formChildren: formChildren
  };
}
function useFireboltForm(_ref18) {
  var schema = _ref18.schema,
    children = _ref18.children,
    onChange = _ref18.onChange,
    onSubmit = _ref18.onSubmit,
    theme = _ref18.theme,
    autoFill = _ref18.autoFill,
    remoteErrors = _ref18.remoteErrors,
    onGoBack = _ref18.onGoBack,
    onFocusField = _ref18.onFocusField,
    onChangeField = _ref18.onChangeField,
    onBlurField = _ref18.onBlurField,
    addons = _ref18.addons,
    classes = _ref18.classes,
    clearRemoteFieldError = _ref18.clearRemoteFieldError;
  var _useFormState = useFormState({
      schema: schema,
      autoFill: autoFill,
      remoteErrors: remoteErrors,
      addons: addons
    }),
    isFormValid = _useFormState.isFormValid,
    formPayload = _useFormState.formPayload,
    modifyPayloadKeys = _useFormState.modifyPayloadKeys,
    fieldValidationErrors = _useFormState.fieldValidationErrors,
    hasFormChanged = _useFormState.hasFormChanged,
    setHasFormChanged = _useFormState.setHasFormChanged,
    setFieldWarning = _useFormState.setFieldWarning,
    clearFieldWarning = _useFormState.clearFieldWarning,
    markAllInvalidFields = _useFormState.markAllInvalidFields,
    fieldManuallySetErrors = _useFormState.fieldManuallySetErrors,
    standalonePropsPresets = _useFormState.standalonePropsPresets,
    requiredFieldsSlugs = _useFormState.requiredFieldsSlugs,
    setRemoteErrors = _useFormState.setRemoteErrors;
  var _useFieldsEvents = useFieldsEvents({
      onChange: onChange,
      onSubmit: onSubmit,
      formPayload: formPayload,
      isFormValid: isFormValid,
      hasFormChanged: hasFormChanged,
      markAllInvalidFields: markAllInvalidFields,
      onGoBack: onGoBack,
      requiredFieldsSlugs: requiredFieldsSlugs,
      remoteErrors: remoteErrors,
      setRemoteErrors: setRemoteErrors
    }),
    handleSubmit = _useFieldsEvents.handleSubmit,
    handleGoBack = _useFieldsEvents.handleGoBack;
  var _useFormRendering = useFormRendering({
      schema: schema,
      modifyPayloadKeys: modifyPayloadKeys,
      children: children,
      formPayload: formPayload,
      fieldValidationErrors: fieldValidationErrors,
      fieldManuallySetErrors: fieldManuallySetErrors,
      theme: theme,
      setFieldWarning: setFieldWarning,
      clearFieldWarning: clearFieldWarning,
      standalonePropsPresets: standalonePropsPresets,
      hasFormChanged: hasFormChanged,
      setHasFormChanged: setHasFormChanged,
      onFocusField: onFocusField,
      onChangeField: onChangeField,
      onBlurField: onBlurField,
      classes: classes,
      clearRemoteFieldError: clearRemoteFieldError,
      remoteErrors: remoteErrors
    }),
    formChildren = _useFormRendering.formChildren;
  var actionsChildData = {
    isFormValid: isFormValid,
    handleSubmit: handleSubmit,
    payload: formPayload,
    currentStep: 1
  };
  return {
    isFormValid: isFormValid,
    handleSubmit: handleSubmit,
    handleGoBack: handleGoBack,
    formChildren: formChildren,
    actionsChildData: actionsChildData
  };
}
var FireboltForm = function FireboltForm(_ref19) {
  var _ref19$submitBtnText = _ref19.submitBtnText,
    submitBtnText = _ref19$submitBtnText === void 0 ? "Next Step" : _ref19$submitBtnText,
    _ref19$previousBtnTex = _ref19.previousBtnText,
    previousBtnText = _ref19$previousBtnTex === void 0 ? "Previous Step" : _ref19$previousBtnTex,
    className = _ref19.className,
    customActionsChild = _ref19.customActionsChild,
    schema = _ref19.schema,
    _ref19$children = _ref19.children,
    children = _ref19$children === void 0 ? [] : _ref19$children,
    onChange = _ref19.onChange,
    onSubmit = _ref19.onSubmit,
    theme = _ref19.theme,
    autoFill = _ref19.autoFill,
    remoteErrors = _ref19.remoteErrors,
    onGoBack = _ref19.onGoBack,
    onFocusField = _ref19.onFocusField,
    onBlurField = _ref19.onBlurField,
    onChangeField = _ref19.onChangeField,
    addons = _ref19.addons,
    clearRemoteFieldError = _ref19.clearRemoteFieldError,
    orderFields = _ref19.orderFields;
  var _useFireboltForm = useFireboltForm({
      schema: schema,
      children: children,
      onChange: onChange,
      onSubmit: onSubmit,
      theme: theme,
      autoFill: autoFill,
      remoteErrors: remoteErrors,
      onGoBack: onGoBack,
      classes: classes,
      onFocusField: onFocusField,
      onBlurField: onBlurField,
      onChangeField: onChangeField,
      addons: addons,
      clearRemoteFieldError: clearRemoteFieldError,
      orderFields: orderFields
    }),
    handleSubmit = _useFireboltForm.handleSubmit,
    formChildren = _useFireboltForm.formChildren,
    actionsChildData = _useFireboltForm.actionsChildData,
    handleGoBack = _useFireboltForm.handleGoBack;
  var ActionsChild = customActionsChild;
  return /* @__PURE__ */React.createElement("form", {
    className: className,
    onSubmit: handleSubmit,
    autoComplete: "off",
    "data-fblt": "firebolt-form"
  }, /* @__PURE__ */React.createElement("div", {
    className: classes["firebolt-form-wrapper"]
  }, formChildren), !!customActionsChild ? /* @__PURE__ */React.createElement(ActionsChild, {
    formData: actionsChildData
  }) : /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("button", {
    color: "secondary",
    style: {
      marginRight: "5px"
    },
    "data-testid": "fbt-submit-button",
    onClick: handleGoBack
  }, previousBtnText), /* @__PURE__ */React.createElement("button", {
    color: "primary",
    onClick: handleSubmit
  }, submitBtnText)));
};
FireboltForm.Insert = Insert;
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var prop = _step11.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }
  return a;
};
var StepForm = function StepForm(props) {
  var _a;
  var _useFirebolt3 = useFirebolt(),
    goNextStep = _useFirebolt3.goNextStep,
    goPreviousStep = _useFirebolt3.goPreviousStep,
    remoteErrors = _useFirebolt3.remoteErrors,
    currentStep = _useFirebolt3.currentStep,
    clearRemoteFieldError = _useFirebolt3.clearRemoteFieldError;
  return /* @__PURE__ */React.createElement(FireboltForm, __spreadValues({
    schema: (_a = currentStep.data) == null ? void 0 : _a.fields,
    onSubmit: goNextStep,
    onGoBack: goPreviousStep,
    remoteErrors: remoteErrors,
    clearRemoteFieldError: clearRemoteFieldError
  }, props));
};
StepForm.Insert = Insert;
export { FireboltForm, FireboltProvider, StepForm, Wizard, createFireboltProvider, useFirebolt };